const { ref, push } = require("firebase/database")


const saveCustomDimensionRequest = function saveCustomDimensionRequest(database, requestData) {
    const dbRef = ref(database, "CustomDimRequests/");

    return push(dbRef, requestData)
}

export { saveCustomDimensionRequest }